/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type StorefrontAboutSection_seller = {
    readonly storefrontProfile: {
        readonly aboutUs: string | null;
        readonly logo: {
            readonly path: string | null;
        } | null;
        readonly establishmentYear: string | null;
    } | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly sellerPreferences: {
        readonly scrollLogoLg: string | null;
        readonly displayStoreAddress: boolean | null;
        readonly storeAddressByAppointmentOnly: boolean | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontContactModal_seller">;
    readonly " $refType": "StorefrontAboutSection_seller";
};
export type StorefrontAboutSection_seller$data = StorefrontAboutSection_seller;
export type StorefrontAboutSection_seller$key = {
    readonly " $data"?: StorefrontAboutSection_seller$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontAboutSection_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "storefrontId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontAboutSection_seller",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "storefrontId",
          "variableName": "storefrontId"
        }
      ],
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "storefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aboutUs",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Photo",
          "kind": "LinkedField",
          "name": "logo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "establishmentYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "kind": "LinkedField",
      "name": "sellerPreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scrollLogoLg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayStoreAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "storeAddressByAppointmentOnly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "kind": "LinkedField",
      "name": "tradeAssociations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontContactModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = '4ba76dbddc9282983b203720783e7530';
export default node;
